import './App.css';
import Main from './pages';

function App() {
  return (
    <div className="container">
        <Main />
    </div>
  );
}

export default App;
